/**
 * safeExpoImage — wrapper Image qui utilise RN Image pur.
 *
 * v1.12.901 — REVERT temporaire vers RN Image uniquement.
 *   Le détection NativeModules.ExpoImage* s'est avérée non fiable sur Android
 *   (Metro bundle expose des entrées partielles même sans le module natif).
 *   Tant que tous les users ne sont pas sur build natif 188+ avec expo-image,
 *   on garde RN Image pour garantir l'affichage correct des images.
 *
 *   La perf expo-image reviendra dans une release ultérieure, une fois les
 *   utilisateurs Android migrés sur build 188+.
 *
 * Mapping API minimal :
 *   - contentFit (cover/contain/fill) → resizeMode RN
 *   - cachePolicy / transition / recyclingKey → ignorés silencieusement
 *   - source : objet { uri } passé tel quel
 */
import React from 'react';
import { Image as RNImage } from 'react-native';

export const isExpoImage = false;

// Mapping contentFit → resizeMode pour fallback RN
const CONTENT_FIT_TO_RESIZE = {
  cover: 'cover',
  contain: 'contain',
  fill: 'stretch',
  none: 'center',
  'scale-down': 'contain',
};

// Composant : RN Image avec mapping des props expo-image (ignorées)
export const Image = React.forwardRef(function SafeImage(props, ref) {
  const {
    contentFit,
    cachePolicy,
    transition,
    recyclingKey,
    placeholder,
    placeholderContentFit,
    priority,
    allowDownscaling,
    enableLiveTextInteraction,
    autoplay,
    ...rest
  } = props;
  const resizeMode = CONTENT_FIT_TO_RESIZE[contentFit] || rest.resizeMode || 'cover';
  return <RNImage ref={ref} {...rest} resizeMode={resizeMode} />;
});
